import { IRouteParameter, IResult, IPointSymbol } from '@/types/map';
import { loadModules } from 'esri-loader';

export default class Route {
  private static _Instances: Map<string, any>;

  private _view!: any;
  private _routeLayer: any; //查找到的路径结果要素

  private constructor(view: any) {
    this._view = view;
  }

  public static getInstance(view: any) {
    let id = view.container.id;
    if (!Route._Instances) {
      Route._Instances = new Map();
    }
    let intance = Route._Instances.get(id);
    if (!intance) {
      intance = new Route(view);
      Route._Instances.set(id, intance);
    }
    return intance;
  }

  public static clear() {
    Route._Instances.clear();
  }
  private async getColor(c: Array<number> | string): Promise<Array<number>> {
    const [Color] = await loadModules(['esri/Color']);
    let nc = new Color(c);
    return [nc.r, nc.g, nc.b, (nc.a * 255) % 256];
  }

  //查找两点之间的最短路径 (对于多个点则按照点序两两寻找)
  public async searchShortestPath(params: IRouteParameter): Promise<IResult> {
    type MapModules = [
      typeof import('esri/geometry/Point'),
      typeof import('esri/Graphic'),
      typeof import('esri/layers/GraphicsLayer'),
      typeof import('esri/rest/route'),
      typeof import('esri/rest/support/RouteParameters'),
      typeof import('esri/rest/support/FeatureSet'),
      typeof import('esri/geometry/Polyline')
    ];
    const [
      Point,
      Graphic,
      GraphicsLayer,
      route,
      RouteParameters,
      FeatureSet,
      Polyline
    ] = await (loadModules([
      'esri/geometry/Point',
      'esri/Graphic',
      'esri/layers/GraphicsLayer',
      'esri/rest/route',
      'esri/rest/support/RouteParameters',
      'esri/rest/support/FeatureSet',
      'esri/geometry/Polyline'
    ]) as Promise<MapModules>);

    // Get the start point and end point
    const paths = params.paths as number[][];
    if (paths.length < 2) {
      return {
        status: -1,
        message: "need 'paths'!"
      };
    }
    // Get the route symbol parameters
    // const showLine = params.showLine !== false;
    const lineColor = params.lineColor || [0, 0, 255, 0.5];
    const lineWidth = params.lineWidth || 5;
    const lineStyle = params.lineStyle;
    // Point the URL to a valid routing service
    const routeUrl = this._view.routeServerUrl;
    if (!routeUrl) {
      return {
        status: -1,
        message: "'routeServerUrl' at mapconfig file is not exist"
      };
    }

    // The stops and route result will be stored in this layer
    if (!(this._routeLayer instanceof GraphicsLayer)) {
      this._routeLayer = new GraphicsLayer();
    }
    const routeLayer = this._routeLayer;
    if (!this._view.map.findLayerById(routeLayer.id)) {
      this._view.map.add(routeLayer);
    }

    // Setup the route parameters
    let stops = new FeatureSet();
    const routeParams = new RouteParameters({
      stops: stops,
      outSpatialReference: this._view.spatialReference
    });

    // Define the symbology used to display the stops
    const stopSymbol: any = {
      type: 'simple-marker', // autocasts as new SimpleMarkerSymbol()
      style: 'circle',
      size: lineWidth,
      color: lineColor || 'rgb(0,0,255)',
      outline: {
        // autocasts as new SimpleLineSymbol()
        width: 0
      }
    };

    // Define the symbology used to display the route
    //测试用的线路
    const routeSymbol: any = lineStyle
      ? await this.makeSymbol(lineStyle)
      : {
          type: 'simple-line', // autocasts as SimpleLineSymbol()
          // type: 'arrow', // autocasts as SimpleLineSymbol()
          color: 'rgb(244,255,0)',
          width: lineWidth || 2
        };

    // Add stops to route one by one
    let prePoint: any = paths[0];
    let firstStop = new Graphic({
      geometry: new Point({
        longitude: prePoint[0],
        latitude: prePoint[1]
      }),
      symbol: stopSymbol
    });
    //add first stop
    routeLayer.add(firstStop);
    stops.features.push(firstStop);
    let all_routePromise = new Array<Promise<any>>();
    for (let i = 1; i < paths.length; ++i) {
      const stop = new Graphic({
        geometry: new Point({
          longitude: paths[i][0],
          latitude: paths[i][1]
        }),
        symbol: stopSymbol
      });
      //add stop
      routeLayer.add(stop);
      stops.features.push(stop);
      //excute the route
      await route
        .solve(routeUrl, routeParams)
        .then((data: any) => {
          const routeResult = data.routeResults[0].route;
          routeResult.symbol = routeSymbol;
          //connect the route start point and end point,and add to routeLayer
          // let route_path = routeResult.geometry.paths[0];
          let route_path = routeResult.geometry;
          route_path.insertPoint(
            0,
            0,
            new Point({
              longitude: prePoint[0],
              latitude: prePoint[1],
              spatialReference: routeResult.geometry.spatialReference
            })
          );
          route_path.insertPoint(
            0,
            route_path.paths[0].length,
            new Point({
              longitude: paths[i][0],
              latitude: paths[i][1],
              spatialReference: routeResult.geometry.spatialReference
            })
          );
          //add to layer
          routeLayer.add(routeResult);
        })
        .catch((err: any) => {
          return {
            status: -1,
            message: err
          };
        });
      //move to next point
      prePoint = paths[i];
      stops.features.shift();
    }

    return {
      status: 0,
      message: 'success',
      result: '222'
      // result: routeResult,//@todo 未经处理的arcgis要素数据
    };
  }

  //清除路径结果
  //移除要素而不移除图层
  public async clearShortestPath(): Promise<IResult> {
    this._routeLayer.removeAll();
    return {
      status: 0,
      message: 'success'
      // result: routeResult,//@todo 未经处理的arcgis要素数据
    };
  }
  private async makeSymbol(
    symbol: IPointSymbol | undefined
  ): Promise<Object | undefined> {
    if (!symbol || (symbol.type && symbol.type.toLowerCase() == 'point-3d'))
      return undefined;
    let result;
    if (symbol.type == 'arrow') {
      let lineColor = symbol.color
        ? await this.getColor(symbol.color)
        : [0, 100, 0, 255];
      let arrowColor =
        symbol.arrow && symbol.arrow.color
          ? await this.getColor(symbol.arrow.color)
          : [255, 255, 255, 255];
      let lineSize: number = (symbol.width || symbol.size || 6) as number;
      let arrowSize = (symbol.arrow && symbol.arrow.size) || lineSize - 1;
      lineSize = Math.max(lineSize, arrowSize); //取线和箭头的最大值
      result = {
        type: 'cim',
        data: {
          type: 'CIMSymbolReference',
          symbol: {
            type: 'CIMLineSymbol',
            symbolLayers: [
              {
                type: 'CIMVectorMarker',
                enable: true,
                size: arrowSize,
                markerPlacement: {
                  type: 'CIMMarkerPlacementAlongLineSameSize',
                  endings: 'Custom',
                  placementTemplate: [
                    (symbol.arrow && symbol.arrow.space) || 14
                  ],
                  offsetAlongLine: 2
                },
                frame: {
                  xmin: -lineSize,
                  ymin: -lineSize,
                  xmax: lineSize,
                  ymax: lineSize
                },
                markerGraphics: [
                  {
                    type: 'CIMMarkerGraphic',
                    geometry: {
                      paths: [
                        [
                          [-lineSize - 2, lineSize - 1],
                          [0, 0],
                          [-lineSize - 2, -lineSize + 1]
                        ]
                      ]
                    },
                    symbol: {
                      type: 'CIMLineSymbol',
                      symbolLayers: [
                        {
                          type: 'CIMSolidStroke',
                          enable: true,
                          color: arrowColor,
                          width: (symbol.arrow && symbol.arrow.width) || 2
                        }
                      ]
                    }
                  }
                ]
              },
              {
                type: 'CIMSolidStroke',
                enable: true,
                width: symbol.width || symbol.size || 6,
                color: lineColor
              }
            ]
          }
        }
      };
    }
    return result;
  }
}
